<template>
  <div class="page">
    <div v-if="model != null">
      <van-panel class="panel-info">
        <div class="content">
          <div class="row" style="margin-top: 0">
            <van-cell class="cell-padding" size="large" center >
              <div class="clerk-item">
                <div class="left align-center">
                  <div class="clerk-head">
                    <van-image round width="70px" height="70px" :src="model.avatarUrl"></van-image>
                  </div>
                  <div class="padding-left-sm">
                    <!-- id -->
                    <div class="left-sm-tag">
                      <van-tag plain type="primary">ID：{{ model.clerkId }}</van-tag>
                    </div>
                    <!-- 店员昵称 -->
                    <div>
                      <span>{{ model.clerkName }}</span>
                    </div>
                  </div>
                </div>
                <div class="right">
                </div>
              </div>
            </van-cell>
          </div>
          <div class="row">
            <span class="label">客服名称</span>
            <span class="value">{{ model.kfName }}</span>
          </div>
          <div class="row" v-if="model.userId">
            <span class="label">用户ID</span>
            <span class="value">{{ model.userId }}</span>
          </div>
          <div class="row" v-if="model.userNickname">
            <span class="label">用户名称</span>
            <span class="value">{{ model.userNickname }}</span>
          </div>
          <div class="row">
            <span class="label">订单号</span>
            <span class="value">{{ model.no }}</span>
          </div>
          <div class="row">
            <span class="label">服务内容</span>
            <span class="value" v-if="model.itemContent">{{model.itemContent}}</span>
          </div>
          <div class="row">
            <span class="label">订单状态</span>
            <van-tag v-if="model.status == 0" plain type="warning">待确认</van-tag>
            <van-tag v-if="model.status == 1" plain type="success">已确认</van-tag>
          </div>
          <div class="row">
            <span class="label">下单时间</span>
            <span class="value">{{formatDate(model.startTime, "YYYY-MM-DD HH:mm:ss") }}</span>
          </div>
          <div class="row" v-if="model.startTime">
            <span class="label">完成时间</span>
            <span class="value">{{formatDate(model.endTime, "YYYY-MM-DD HH:mm:ss") }}</span>
          </div>
          <div class="row" v-if="model.clerkConfirmTime">
            <span class="label">确认时间</span>
            <span class="value">{{formatDate(model.clerkConfirmTime, "YYYY-MM-DD HH:mm:ss") }}</span>
          </div>
          <div class="row">
            <span class="label">订单金额</span
            ><span class="value">￥{{ formatPrice(model.totalAmount) }}</span>
          </div>
          <div class="row">
            <span class="label">提成金额</span>
            <span class="value">￥{{ formatPrice(model.clerkWagesAmount) }}</span>
          </div>
          <div class="row" v-if="model.remark">
            <span class="label">订单备注</span>
            <span class="value">{{model.remark}}</span>
          </div>
          <div class="row" v-if="model.continueRemark">
            <span class="label">续单备注</span>
            <span class="value" >{{model.continueRemark}}</span>
          </div>
          <div class="row" v-if="model.photoUrls && model.photoUrls.length > 0" >
            <span class="label">订单截图</span>
            <span class="value">
              <img v-for="(item, index) in model.photoUrls" :key="index" @click="handleclickImg(model.photoUrls,index)"
                   :src="item" width="60" height="60" style="border-radius: 5px;margin-left: 2px;" />
          </span>
          </div>
        </div>
        </van-panel>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Button,
  Cell, CellGroup,
  Dialog,
  Field,
  Icon,
  ImagePreview,
  Panel,
  Tag,
  Image,
  Toast, Uploader,
} from "vant";
import Decimal from "decimal.js";
import moment from "moment";
import VueClipboards from "vue-clipboards";
import {
  cancelOrder,
  confirmOrder,
  startService,
  remindContinued,
} from "@/api/clerk/order";
import { addOrderContinuedApply } from "@/api/clerk/order_continued_apply";
import lrz from 'lrz'
import {
  getOutOrder,
} from "@/api/kf/out-order"


Vue.use(Panel)
  .use(Cell)
  .use(CellGroup)
  .use(Button)
  .use(Tag)
  .use(Icon)
  .use(Toast)
  .use(Dialog)
  .use(Uploader)
  .use(Image)
  .use(Field);

Vue.use(VueClipboards);

export default {
  name: "out-order-detail",
  components: {
  },

  data() {
    return {
      showViolation: false,
      fileList: [],
      continuedApplyFileList: [],
      ORDER: this.$store.state.order,
      UserInfoEnum: this.$store.state.UserInfoEnum,
      show: false,
      value: "",
      model: null,
      sign: null,
      btnConfirmDisabled: true,
      confirmCountDown: 3,
      cancelCountDown: null,
      canClerkCancelOrder: null,
      showOrderContinuedApplyDialog: false,
      orderContinuedApplyMessage: null,
      isVerify: false,
      canClerkCancelOrderUploadWaitService: false,
      clerkContinuedApplyUpload: false,
      remindUserContinued: false,
    };
  },
  computed: {
    copyUserWechatId() {
      if (this.model) {
        return this.model.userWechatId;
      }
      return null;
    },
  },
  methods: {
    handleclickImg(photoUrls, index) {
      ImagePreview({
        images: photoUrls,
        startPosition: index,
      });
    },
    changeShowViolation(val){
      this.showViolation = val
    },

    // 读取前
    beforeRead(file) {
      return true;
    },
    // 读取后
    afterRead(file) {
      let files = []
      if (!file.length) {
        files.push(file)
      } else {
        files = file
      }
      for (let item of files) {
        // 压缩图片
        lrz(item.file, {
          width: 800
        }).then(function (res) {
          item.content = res.base64
        })
      }
    },
    // 删除前
    beforeDelete(file) {
      if (this.fileList != null && this.fileList.length == 1) {
        Toast('至少保留1张照片');
        return false;
      }
      return true;
    },
    // 续单申请截图读取后
    continuedApplyAfterRead(file) {
      let files = []
      if (!file.length) {
        files.push(file)
      } else {
        files = file
      }
      for (let item of files) {
        // 压缩图片
        lrz(item.file, {
          width: 800
        }).then(function (res) {
          item.content = res.base64
        })
      }
    },
    cancellation() {
      if (this.value == "") {
        return Toast("请输入原因");
      }
      // 开启截图开关(服务中的才需上传截图)
      if(this.model.status === 1 && this.$ClerkPermission.requireUploadPictureWhenCancelWaitServiceOrder && this.fileList.length == 0){
        return Toast("请上传截图");
      }
      Toast.loading({
        mask: true,
        message: "加载中...",
      });
      cancelOrder(this.$route.params.id, this.value,JSON.stringify(this.fileList)).then((res) => {
        Toast.clear();
        const data = res.data;
        let options = {};
        if (data.code == 0) {
          this.model = null;
          options = {
            title: "取消订单成功",
          };
        } else {
          options = {
            title: "取消订单失败",
            message: data.msg,
          };
        }
        Dialog.alert(options).then(() => [this.loadData()]);
      });

    },
    formatDate(date, format) {
      if (!date) {
        return "";
      }
      if (!format) {
        format = "YYYY-MM-DD";
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString();
      }
      return "";
    },
    // 格式化时间差
    formatTimeDiff(start, end, status) {
      start = moment(start);
      end = moment(end);
      const diffSeconds = end.diff(start, "seconds");
      if (status === 2 && diffSeconds < 1) {
        return '即将完成'
      }
      if (diffSeconds < 60) {
        return `${diffSeconds}秒`;
      }
      const diffMinutes = end.diff(start, "minutes");
      if (diffMinutes < 60) {
        return `${diffMinutes}分钟`;
      }
      const diffHours = end.diff(start, "hours");
      if (diffHours < 24) {
        return `${diffHours}小时`;
      }
      const diffDays = end.diff(start, "days");
      return `${diffDays}天`;
    },
    copyCallback(success) {
      if (success) {
        Toast("复制成功");
      } else {
        Toast("复制失败，请长按文本复制");
      }
    },
    // 启用“确认订单”按钮倒计时
    startConfirmEnableCountDown() {
      let interval = window.setInterval(() => {
        this.confirmCountDown--;
        if (this.confirmCountDown <= 0) {
          window.clearInterval(interval);
          this.btnConfirmDisabled = false;
        }
      }, 1000);
    },
    hideCancelOrderButtonCountDown() {
      let interval = window.setInterval(() => {
        this.cancelCountDown--;
        if (this.cancelCountDown <= 0) {
          window.clearInterval(interval);
          this.canClerkCancelOrder = false;
        }
      }, 1000);
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: "加载中...",
      });
      getOutOrder(this.$route.params.id).then((res) => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          this.model = data.outOrder;
        } else {
          Dialog.alert({
            title: "加载失败",
            message: data.msg,
          });
        }
      });
    },
    confirmOrder() {
      Toast.loading({
        mask: true,
        message: "请稍候...",
      });
      confirmOrder(this.$route.params.id).then((res) => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: "接单成功",
          }).then(() => {
            this.loadData();
          });
        } else {
          this.loadData();

          if (data.msg == this.$store.state.label.clerkLabel + "未实名") {
            this.isVerify = true;
          } else {
            Dialog.alert({
              title: "接单失败",
              message: data.msg,
            });
          }
        }
      });
    },
    // 取消订单
    cancelOrder() {
      Dialog.confirm({
        title: "确定要取消订单？",
        message: "此操作不可撤销！",
      }).then(() => {
        Toast.loading({
          mask: true,
          message: "请稍候...",
        });
        cancelOrder(this.$route.params.id).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            this.model = null;
            Dialog.alert({
              title: "取消订单成功",
            }).then(() => [this.loadData()]);
          } else {
            Dialog.alert({
              title: "取消订单失败",
              message: data.msg,
            });
          }
        });
      });
    },
    clickRemindContinued(){
      // 弹出框
      Dialog.confirm({
        title: '提醒用户续单',
        message:'每单限一次哦~'
      }).then(() => {
        Toast.loading({
          message: '提醒中...',
          forbidClick: true,
        });
        remindContinued(this.$route.params.id).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: "提醒成功",
            });
            this.model.remind=true
          } else {
            Dialog.alert({
              title: "提醒失败",
              message: data.msg,
            });
            this.loadData();
          }
        });
      })
    },
    // 开始服务
    startService() {
      Dialog.confirm({
        title: "开始服务",
        message: "请确认已成功添加用户微信！\n点击确认后开始服务计时。",
      }).then(() => {
        Toast.loading({
          mask: true,
          message: "请稍候...",
        });
        startService(this.$route.params.id).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: "已开始服务",
            }).then(() => {
              this.loadData();
            });
          } else {
            this.loadData();
            Dialog.alert({
              title: "开始服务失败",
              message: data.msg,
            });
          }
        });
      });
    },
    onOrderContinuedApplyDialogClose(action, done) {
      if (action == "confirm") {
        if (
          this.orderContinuedApplyMessage != null &&
          this.orderContinuedApplyMessage.length > 100
        ) {
          Toast("消息不能超过100个字");
          return done(false);
        }

        // 开启截图开关
        if(this.clerkContinuedApplyUpload && this.continuedApplyFileList.length == 0){
          Toast("请上传至少一张截图");
          return done(false);
        }
        Toast.loading({
          mask: true,
          message: "请稍候...",
        });
        addOrderContinuedApply(
          this.$route.params.id,
          this.orderContinuedApplyMessage,
          JSON.stringify(this.continuedApplyFileList)
        ).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            Dialog.alert({
              title: "申请成功",
            }).then(() => {
              this.loadData();
            });
          } else {
            this.loadData();
            Dialog.alert({
              title: "申请失败",
              message: data.msg,
            });
          }
        });

        done();
      } else {
        done();
      }
    },
    refundImgClick(i){
      ImagePreview({
        images: this.model.refundPhotoUrls,
        startPosition: i,
      })
    },
    imgClick(i) {
      ImagePreview({
        images: this.model.orderFeedBack.photoUrls,
        startPosition: i,
      });
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    $route: function (to, from) {
      //从订单反馈过来的话就直接重新loadDate()
      if (from.meta.title === "订单反馈") {
        this.loadData();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 100px;
  .van-panel__header{
    padding:0;
  }
  .panel-info {

    .content {
      font-size: 14px;
      padding: 30px 15px 15px;

      .row {
        .cell-padding{
          padding: 0;
          .clerk-item {
            display: flex;
            align-items: center;
            .userMemo {
              color: #999;
            }
            .left {
              flex: 1;
              display: flex;
              .service-info {
                color: #333;
              }
              .created {
                color: #555;
                margin-bottom: 5px;
              }
              .clerk-head {
                position: relative;
                padding: 10px;
                .avatarFrame {
                  position: absolute;
                  top: 0;
                  left: 0;
                }
                .level {
                  position: absolute;
                  left: 50%;
                  height: 10px;
                  font-size: 10px;
                  white-space: nowrap;
                  bottom: 0px;
                  transform: translateX(-50%);
                }
              }
              .padding-left-sm div span{
                margin-right: 4px;
              }
            }
            .right {
              text-align: right;
              min-width: 30px;
              .total-amount {
                color: #333;
              }
            }
          }
        }
      }
    }
  }

  .row {
    display: flex;
    color: #333;
    margin: 10px 0;
    align-items: center;
  }

  .label {
    width: 80px;
    color: #888;
  }

  .value {
    flex: 1;
  }

  .bottom-bar {
    padding: 10px 15px;
    /*background: #fff;*/
    /*box-shadow: 0 0 3px 0px #333;*/
    /*position: fixed;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*right: 0;*/
  }

  .commentBox {
    width: 100%;
    background: #fff;
    padding: 15px;
    margin-top: 20px;
    box-sizing: border-box;
  }

  .imgStyle {
    margin-left: 10px;
    flex: 0 0 15%;
    height: 0;
    padding-bottom: 15%;
    overflow: hidden;
    position: relative;
  }

  .screenshot {
    width: 100%;
    display: flex;
    align-content: flex-start;
    flex-flow: row wrap;
  }

  .screenshotImg {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .module {
    margin-top: 15px;
    padding: 0px 15px;
    position: relative;

    /deep/ .van-cell {
      padding: 15px 0;
      background: transparent;
      font-size: 14px;
      line-height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;

      &.module-title {
        padding-bottom: 0;
      }

      .van-cell__title {
        width: 90px;
        flex: none;
        box-sizing: border-box;
        font-weight: 600;
        color: #333333;
      }

      .van-cell__value {
        font-weight: 400;
        color: #999999;
      }

      &.van-cell--required {
        &::before {
          left: 0px;
        }
      }
    }
  }

  .image-uploader {
    /deep/ .van-uploader__wrapper {
      .van-uploader__preview {
        .van-uploader__preview-delete {
          top: 0;
          right: 0;
          color: var(--primary-color);
        }
      }
    }
  }

}
</style>
